'use strict'

module.exports = function (ngModule) {
  ngModule.controller('RedeemCtrl', ["$scope", "$http", "$log", "$window", "$location", "Auth", "redeemData", "$translate", function ($scope, $http, $log, $window, $location, Auth, redeemData, $translate) {
    // $scope.alerts = []
    $scope.alert = {
      type: '',
      message: '',
      data: ''
    }
    $scope.redeem = {
      keycode: ''
    }
    $scope.isLoggedIn = Auth.isLoggedIn()
    if (!$scope.isLoggedIn) {
      $scope.alert = {
        type: 'not-login'
      }
    }
    $scope.messages = {
      hasHelpMessage: redeemData.length > 0,
      helpMessages: redeemData
    }

    $scope.resetRedeem = function () {
      $scope.redeem.keycode = ''
      $scope.alerts = []
    }

    $scope.inputRedeem = function (keycode, limitSku, partnerName) {
      $scope.redeem.messageText = ''
      keycode = keycode.replace(/\s/g, '')

      $http({
        method: 'GET',
        url: '/api/check_redeem_account',
        headers: Auth.getJwtHeader()
      }).then(function (userData) {
        $log.debug('check', userData)
        if (_.has(userData, 'data.pass') && userData.data.pass === true) {
          $http({
            method: 'POST',
            url: '/api/redeem',
            headers: Auth.getJwtHeader(),
            data: {
              keycode: keycode,
              sku: limitSku,
              partner_name: partnerName,
              region: $translate.proposedLanguage()
            }
          })
            .then(function (data) {
              $log.debug('doRedeem', data)
              if (_.has(data.data, 'applied')) {
                $scope.alert = {
                  type: 'applied',
                  data: data.data['redirect']
                }
              } else {
                $scope.alert = {
                  type: 'success',
                  data: data.data['redirect']
                }
              }
            })
            .catch(function (err, status) {
              $log.debug(err, status)
              if (err.error && err.error.message) {
                $scope.alert = {
                  type: 'failure',
                  message: 'REDEEM_CODE_INVALID'
                }
              } else {
                $scope.alert = {
                  type: 'failure',
                  message: err.data.code || 'REDEEM_CODE_INVALID'
                }
              }
            })
        } else {
          $location.path('/update_profile').search({ 'redirect': 'redeem' })
        }
      }).catch(function (err) {
        $log.debug(err)
        if (err.error && err.error.message) {
          $scope.alert = {
            type: 'failure',
            message: err.error.message
          }
        } else {
          $scope.alert = {
            type: 'failure',
            message: 'REDEEM_CODE_INVALID'
          }
        }
      })
    }
  }])
  .controller('PresonusCtrl', ["$scope", "$http", "$log", "$window", "$location", "Auth", "redeemData", "$translate", function ($scope, $http, $log, $window, $location, Auth, redeemData, $translate) {
    $scope.alert = {
      type: '',
      message: '',
      data: ''
    }
    var queryParams = $location.search()
    $scope.spark = {
      sn: (queryParams.sn) ? queryParams.sn : ''
    }
    $scope.isLoggedIn = Auth.isLoggedIn()
    if (!$scope.isLoggedIn) {
      $scope.alert = {
        type: 'not-login'
      }
    }
    // $scope.messages = {
    //   hasHelpMessage: redeemData.length > 0,
    //   helpMessages: redeemData
    // }

    $scope.resetForm = function () {
      $scope.spark.sn = ''
      $scope.alerts = []
    }

    $scope.registerSpark = function (hwSn) {
      hwSn = hwSn.replace(/\s/g, '')

      $http({
        method: 'POST',
        url: '/api/hw_register',
        headers: Auth.getJwtHeader(),
        data: {
          sn: hwSn
        }
      })
        .then(function (data) {
          $log.debug('doRedeem', data)
          if (_.has(data.data, 'applied')) {
            $scope.alert = {
              type: 'applied',
              message: 'SPARK_PRESONUS_ALREADY',
              code: data.data.code
            }
          } else {
            $scope.alert = {
              type: 'success',
              message: 'SPARK_PRESONUS_SUCCESS',
              code: data.data.code
            }
          }
        })
        .catch(function (err, status) {
          $log.debug(err, status)
          if (err.error && err.error.message) {
            $scope.alert = {
              type: 'failure',
              message: 'SPARK_SN_INVALID'
            }
          } else if (err.error && err.error.code) {
            $scope.alert = {
              type: 'failure',
              message: err.error.code
            }
          } else {
            $scope.alert = {
              type: 'failure',
              message: err.data.code || 'SPARK_SN_INVALID'
            }
          }
        })
    }
  }])
}



//////////////////
// WEBPACK FOOTER
// ./js/controllers/redeem.js
// module id = 52
// module chunks = 0